import omit from 'lodash/omit';
import extend from 'lodash/extend';
import values from 'lodash/values';

export const FACETS_OBJ_KEY = '_facetsForTracking';

export function embedFacetsObj({ name, values, isFilterUserValue } = {}) {
  return {
    [FACETS_OBJ_KEY]: { name, values, isFilterUserValue },
  };
}

export function extractFacetsAndProperties(propertiesWithFacets) {
  const properties = [];
  const facetsMap = {};

  propertiesWithFacets.forEach((item) => {
    const id = item.property;
    properties.push(omit(item, [FACETS_OBJ_KEY]));

    if (facetsMap[id]) {
      extend(facetsMap[id], {
        values: facetsMap[id].values.concat(item[FACETS_OBJ_KEY].values),
      });
    } else {
      if (item[FACETS_OBJ_KEY]) {
        facetsMap[id] = item[FACETS_OBJ_KEY];
      }
    }
  });

  return {
    properties,
    facets: values(facetsMap),
  };
}
